import { gql } from '@apollo/client';
const ADD_CONVERSATION = gql `
  mutation AddConversation($url: String, $title: String, $userIds: [ID]) {
    addConversation(pageUrl: $url, title: $title, userIds: $userIds) {
      conversation {
        id
        pageUrl
        title
      }
    }
  }
`;
export default ADD_CONVERSATION;
